import {
    SET_SWITCH_PURPOSES,
    SET_SWITCH_VENDORS,
    SET_SWITCH_CUSTOM,
    ADD_SWITCH_PURPOSE,
    REMOVE_SWITCH_PURPOSE,
    ADD_SWITCH_VENDOR,
    REMOVE_SWITCH_VENDOR,
    ADD_SWITCH_CUSTOM,
    REMOVE_SWITCH_CUSTOM,
} from "../action_types";

import store from "../store";

export const setSwitchPurposes = (purposes) => ({
    type: SET_SWITCH_PURPOSES,
    purposes,
});

export const setSwitchVendors = (vendors) => ({
    type: SET_SWITCH_VENDORS,
    vendors,
});

export const setSwitchCustom = (custom) => ({
    type: SET_SWITCH_CUSTOM,
    custom,
});

export const addSwitchPurpose = (id) => ({
    type: ADD_SWITCH_PURPOSE,
    id,
});

export const removeSwitchPurpose = (id) => ({
    type: REMOVE_SWITCH_PURPOSE,
    id,
});

export const addSwitchVendor = (id) => ({
    type: ADD_SWITCH_VENDOR,
    id,
});

export const removeSwitchVendor = (id) => ({
    type: REMOVE_SWITCH_VENDOR,
    id,
});

export const addSwitchCustom = (id) => ({
    type: ADD_SWITCH_CUSTOM,
    id,
});

export const removeSwitchCustom = (id) => ({
    type: REMOVE_SWITCH_CUSTOM,
    id,
});

export const boundSetSwitchPurposes = (purposes) => store.dispatch(setSwitchPurposes(purposes));
export const boundSetSwitchVendors = (vendors) => store.dispatch(setSwitchVendors(vendors));
export const boundSetSwitchCustoms = (customs) => store.dispatch(setSwitchCustom(customs));
export const boundAddSwitchPurpose = (id) => store.dispatch(addSwitchPurpose(id));
export const boundRemoveSwitchPurpose = (id) => store.dispatch(removeSwitchPurpose(id));
export const boundAddSwitchVendor = (id) => store.dispatch(addSwitchVendor(id));
export const boundRemoveSwitchVendor = (id) => store.dispatch(removeSwitchVendor(id));
export const boundAddSwitchCustom = (id) => store.dispatch(addSwitchCustom(id));
export const boundRemoveSwitchCustom = (id) => store.dispatch(removeSwitchCustom(id));